import React, { Fragment } from "react";

const AcceptApplicant = ({
  user: { avatar, channelid, companyname, firstname, lastname, location },
  setAcceptApplicant,
  acceptApplication,
  JobApplication,
  currentIndex,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() =>
              setAcceptApplicant({ request: false, confirm: false })
            }
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font bold">{companyname}</span>
                </li>
                <li className="user-online-item">
                  {firstname} {lastname}
                </li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text white">
            Would you like to accept the current applicant?
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-dark-black white"
              onClick={() => {
                acceptApplication(JobApplication, currentIndex, channelid);
                setAcceptApplicant({ request: false, confirm: true });
              }}
            >
              <i className="far fa-check-circle fa-sm mr-5 blue"></i>
              Confirm
            </button>
            <button
              className="user-request-button background-blue"
              onClick={() =>
                setAcceptApplicant({ request: false, confirm: false })
              }
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AcceptApplicant;
